import { useEffect, useMemo, useState } from 'react';
import { CustomButton, InputSelect } from 'shared_ui_components';
import classes from './QualifyingCriteria.module.css';
import {
  useModuleCriteriaConfigMutation,
  useModuleCriteriaConfigQuery,
} from './ModuleAssessment.queries';

const defaultOpt = { value: 70, label: '70%' };

const QualifyingCriteriaConfig = () => {
  const [moduleCriteria, setModuleCriteria] = useState({ value: '', label: 'Loading...' });

  const { data, isLoading } = useModuleCriteriaConfigQuery();

  useEffect(() => {
    if (isLoading) return;
    const value = data?.module_assessments?.rating_to_qualify || 70;
    if (value) setModuleCriteria({ value, label: `${value}%` });
  }, [data, isLoading]);

  const options = useMemo(() => {
    const opts = [];
    let value = 5;
    do {
      opts.push({ value, label: `${value}%` });
      value += 5;
    } while (value <= 100);
    return opts;
  }, []);

  const criterion_uuid = useMemo(() => {
    if (!data) return '';
    return data?.module_assessments?.uuid;
  }, [data]);

  const onModuleCriteriaChange = (opt) => setModuleCriteria(opt);
  const resetModule = () => setModuleCriteria(defaultOpt);

  const { mutate } = useModuleCriteriaConfigMutation();
  const onSubmit = () => mutate({ criterion_uuid, min_value: moduleCriteria?.value });

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <h1>Module Quizzes</h1>
        <p>Rating to qualify</p>
        <InputSelect
          disabled={isLoading}
          value={moduleCriteria}
          onChange={onModuleCriteriaChange}
          options={options}
        />
        <button type="button" onClick={resetModule} className={classes.reset}>
          Reset to default
        </button>
      </div>
      <CustomButton onClick={onSubmit}>Save</CustomButton>
    </div>
  );
};

export default QualifyingCriteriaConfig;
